const images = {
	logo			: require('./../images/logo.jpg'),
	logoGray		: require('./../images/logoGray.png'),
	navIcon			: require('./../images/navIcon.svg'),

	homeHeader		: require('./../images/homeHeader.jpg'),
	star 			: require('./../images/star.svg'),
	map 			: require('./../images/map.svg'),

	blog 				: require('./../images/blog.svg'),
	chatbot 			: require('./../images/chatbot.svg'),
	googleAnalytics 	: require('./../images/googleAnalytics.svg'),
	performanceAudits 	: require('./../images/performanceAudits.svg'),
	ppc 				: require('./../images/ppc.svg'),
	seo 				: require('./../images/seo.svg'),
	webDesign 			: require('./../images/webDesign.svg'),

	social : {
		facebook 				: require('./../images/social/facebook.svg'),
		linkedIn 				: require('./../images/social/linkedIn.svg'),
		twitter 				: require('./../images/social/twitter.svg'),
		medium 					: require('./../images/social/medium.svg'),
		youtube 				: require('./../images/social/youTube.svg'),
		website 				: require('./../images/social/website.svg'),

		facebookBlank 			: require('./../images/social/facebookBlank.svg'),
		linkedInBlank 			: require('./../images/social/linkedInBlank.svg'),
		twitterBlank 			: require('./../images/social/twitterBlank.svg'),
		instagramBlank 			: require('./../images/social/instagramBlank.svg'),
		mediumBlank 			: require('./../images/social/mediumBlank.svg'),
		youtubeBlank 			: require('./../images/social/youtubeBlank.svg'),
	}
};

export default images;



// WEBPACK FOOTER //
// ./src/config/images.js